import { onConfig } from "@/config";

export let DATA_OVERVIEW_ENDPOINT = "";

onConfig((config) => {
  DATA_OVERVIEW_ENDPOINT = config.VUE_APP_BASIC_URL + "/ws/dataoverview";
});

export let ALARMS_ENDPOINT = "";
onConfig((config) => {
  ALARMS_ENDPOINT = config.VUE_APP_BASIC_URL + "/dataoverview/alarms";
});
export const EMPTY_ALARMS = [];


export const EMPTY_DATA_OVERVIEW_LIST = [];
